import { render, staticRenderFns } from "./DescontoProgressivo.vue?vue&type=template&id=399778bc&"
import script from "./DescontoProgressivo.vue?vue&type=script&lang=js&"
export * from "./DescontoProgressivo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports